<nb-layout>
  <nb-layout-header>
    <div class="d-flex flex-row flex-fill">
      <div class="d-flex align-items-end flex-grow-1">
        <img src="assets/logo_altavia.png" height="32px" class="me-3" />
        <div class="fs-4">POPNEXT</div>
      </div>
      <div class="d-flex align-items-end" *ngIf="isLogged">
        <nb-actions size="small">
          <nb-action>
            <a nbButton [shape]="'round'" [routerLink]="['/campaigns/create']"
              >Create a campaign</a
            >
          </nb-action>
          <nb-action class="user-action">
            <nb-user
              [nbContextMenu]="userMenu"
              [onlyPicture]="userPictureOnly"
              [name]="user?.name"
              [picture]="user?.picture"
            >
            </nb-user>
          </nb-action>
        </nb-actions>
      </div>
    </div>
  </nb-layout-header>
  <nb-layout-column><router-outlet></router-outlet></nb-layout-column>
</nb-layout>
